import HeaderBanner from './HeaderBanner';
const OctopussFacilityManagement = () => {

    return (
        <>
            <HeaderBanner heading={'Facility Management System'} imagePath="assets/images/background/1.jpg" />
            <section className="about about-1" id="about-1" style={{ background: 'rgb(235, 230, 230)', marginTop: '30px' }}>
                <div className="container">
                    <div className="row" >
                        <div className='center-heading'>
                            <h2 className="heading-with-border center-heading">Facility Management Services</h2>
                        </div>

                    </div>
                    <div className="row" >
                        <div className="col-12 col-lg-12">
                            <p className='octo-para'>
                                Octopuss India is a professionally managed facility management service company based in Allahabad and Kolkata, India, and is ISO 9001-2015 certified. The company specializes in providing residential and commercial property Facility management services, making it a trusted partner for safeguarding both personal and business assets.
                            </p>
                            <p className='octo-para'>
                                Ownership and Management- The company is owned and managed by professionals with over 12+ years of combined experience in the security and facility management industry. This wealth of experience enables them to provide the best services to their customers, helping them secure their properties and businesses, and offering peace of mind.
                            </p>
                        </div>

                    </div>

                    <div className="heading heading-11">
                        <div className="row">
                            <div className="col-12">
                                <p className="heading-with-border">A) HOUSE KEEPING SERVICES:-</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-12">
                                <p className='octo-para'>
                                    House keeping services for Corporate office, Office campus, Industries, IT Industries, Institutes and Commercial Complex by Latest Methods and well trained. Housekeeping Technical Persons with pleasant Working Environment.
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-12">
                                <ul>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Professional Cleaning services and related maintenance services by Latest methods
                                        in the premises
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Moping and cleaning of all floors.
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Cleaning of Dust, Cobwebs as and when requires by Vacum cleaner.
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Upkeep of all ceramic fittings and other statutory fittings and providing disinfectant materials and air purifiers for wash area and washbasins
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Cleaning of Toilets as and requires with frequent interval.
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Cleaning of window panels, glasses, partitions etc.
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Cleaning of all waste paper baskets
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Cleaning of all telephones including intercoms and super phones.
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Keeping consumable items like hand wash soap, phenyl, urinal cubes, room spray, Glass cleaner, brasso & silvo polishing liquid, soap oil cleaning powder, Brooms, Clearning cloths, mop stick, cotton waste, mop cloth, glass cloth, brushes, odonil and
                                        Other Clearning items
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div className="heading heading-11">
                        <div className="row">
                            <div className="col-12">
                                <p className="heading-with-border">B) GUEST HOUSE CARE TAKING:-</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-12">
                                <p className='octo-para'>
                                    Care taking of Guest Houses and providing all guest services to Guest on the Round 'O' Clock services with high standard on behalf of the principle employer and employing the following personnel
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-12">
                                <ul>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Caretaker
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Cook
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Steward
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        House Keeping
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Technical labour
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Gardener
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div className="heading heading-11">
                        <div className="row">
                            <div className="col-12">
                                <p className="heading-with-border">C) GARDENING / LANDSCAPING SERVICES-:-</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-12">
                                <p className='octo-para'>
                                    We are Developing and Maintaining the Garden, lawns by the experienced gardeners under
                                    the control of our Horticulturist who have the sound knowledge in the field of Horticulture.
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-12">
                                <ul>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Watering, weeding, mowing regularly,
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Top dressing, pruning of the plants
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Periodical spraying of pesticides and fungicides and fertilizers
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Renovation of old lawns
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Planting of seasonal varaities
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        Nursery Maintenance in the campus like - Potting, repotting, propogation activities, compost preparation
                                    </li>
                                    <li className="octo-para"><i className="fas fa-circle circle-list-icon"></i>
                                        General maintenance work like - Flower vase and pot arrangements, shifting of manure mixtures
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                </div>
            </section >
        </>
    )
}

export default OctopussFacilityManagement;